import $http from "../axios";

const actions = {
  createProduct(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("create-product", data, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

export default {
  actions
};
